import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

/**
 * Hook to get the reCAPTCHA execute function
 * Use this in your form submission handler for invisible reCAPTCHA v3
 *
 * @example
 * const { execute, isLoaded } = useReCaptcha()
 *
 * const handleSubmit = async (values) => {
 *   const token = await execute('submit')
 *   if (token) {
 *     // Send token to backend for verification
 *   }
 * }
 */
export const useReCaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha()

    const execute = async (
        action: string = 'submit',
        onSuccess?: (token: string) => void | Promise<void>
    ): Promise<string | null> => {
        if (!executeRecaptcha) {
            console.warn('reCAPTCHA not loaded yet')
            return null
        }

        try {
            const token = await executeRecaptcha(action)
            if (onSuccess) {
                await onSuccess(token)
            }
            return token
        } catch (error) {
            console.error('reCAPTCHA error:', error)
            return null
        }
    }

    return { execute, isLoaded: !!executeRecaptcha }
}
